import React from 'react'

import {
  Modal,
  Button,
  Icon
} from '../index'
import { t } from '@insight/toolkit-utils'
import { getCurrentLocale } from '@insight/toolkit-utils';

const ShortTermLeasingInfoModal = ({
    materialId,
    setIsMarketoForm,
    onClose
}) => {
    const locale = getCurrentLocale('insight_locale');
    const leasingOptions = ['Operating lease', 'Capital lease', 'Finance lease', 'Product Roll Outs', 'Installment Payment Plans']
    const bannerURL = 'https://www.insight.com/content/dam/global/na/us/shop/shop-banner/leasing-and-finance-services-banner.png'
    const handleClick = () => {
        setIsMarketoForm(true)
    }
    return (
            <Modal
                isOpen={true}
                size="medium"
                onClose={onClose}
                closeOnOutsideClick={true}
            >
                <div className="c-short-term-leasing__info">
                    <Modal.Header onClick={onClose}>
                        <div>{t('Insight leasing and finance services')}</div>
                    </Modal.Header>
                    <img className="c-short-term-leasing__info-banner" src={bannerURL} />
                    <Modal.Body
                        id="short-term-leasing-info-modal"
                        data-testid="short-term-leasing-info-modal"
                    >
                        <div className="c-modal__description">
                            <div className="c-interest-text">
                                {t('Insight offers flexible and convenient ways to help you manage your technology and budget. Insight Global Finance (IGF) will help you overcome budget limitations with a wide variety of finance options. Finance everything from hardware and software to peripherals, service contracts and installation — in one easy package.')}
                            </div>
                            <div>
                                {t('IGF makes the process simple, no matter how you choose to finance')}:
                            </div>
                            <ul>
                                {leasingOptions?.map((option)=>(
                                    <li>{t(option)}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="c-short-term-leasing__info">
                            <div className="c-interest-text">{t('Interested in leasing this product?')}</div>
                            <div className="c-form-button">
                                <Button
                                color="primary"
                                className="c-short-term-leasing__info-button"
                                onClick={handleClick}
                                >
                                    {t('Fill out our quick inquiry form →')}
                                </Button>
                            </div>
                            <div className="c-content-link">
                                <Button
                                color="inline-link"
                                target="_blank"
                                href={`/${locale}/what-we-do/services/procurement-services/technology-financing-and-leasing.html?refCode=Apple-finance-and-leasing-services-contact-us`}
                                >
                                    {t('Visit our finance and leasing page to learn more')}
                                    <Icon
                                        className="c-add-item-to-cart__carrier__icon"
                                        type="error"
                                        title="Visit our finance and leasing page to learn more"
                                        icon="open"
                                    />
                                </Button>
                            </div>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
    )
}
export default ShortTermLeasingInfoModal;
